/**
 * Party Manager API Contracts
 * 
 * Zodios-based type-safe contracts for cross-domain communication
 * Separate export to avoid polluting main API
 */

// Zodios API definitions (for MCP servers and API clients)
export { partyManagerApi } from './integration/contracts/zodios-api';

// Contract types (for type-safe API communication)
export type {
  PersonSummary,
  OrganizationSummary,
  AuthenticationSummary
} from './integration/contracts/PartyManagerSummaryModels';

export type {
  PersonQueryCriteria,
  OrganizationQueryCriteria
} from './integration/contracts/PartyQueryCriteria';

// Person API contracts
export {
  CreatePersonRequestSchema,
  UpdatePersonRequestSchema,
  PersonSchema,
  PersonListResponseSchema,
  PersonContract
} from './integration/contracts/person-api-contract';

export type {
  CreatePersonRequest,
  UpdatePersonRequest
} from './integration/contracts/person-api-contract';

// Organisation API contracts  
export {
  CreateOrganisationRequestSchema,
  UpdateOrganisationRequestSchema,
  OrganisationSchema,
  OrganisationListResponseSchema,
  OrganisationContract
} from './integration/contracts/organisation-api-contract';

export type {
  CreateOrganisationRequest,
  UpdateOrganisationRequest,
  OrganisationListResponse
} from './integration/contracts/organisation-api-contract';